
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  withNicheHint: {
    id: "WithNicheHint.hint",
    defaultMessage: "Note:",
  },
  withNicheMessage: {
    id: "WithNicheMessage.message",
    defaultMessage: "Length of washbasin = dimensions of finished niche minus 8 mm. Please subtract 4 mm per washbasin side during configuration. Please consider structural projections.",
  },
  depthRequiredHint: {
    id: "DepthRequiredHint.hint",
    defaultMessage: "Note:",
  },
  depthRequiredMessage: {
    id: "DepthRequiredMessage.message",
    defaultMessage: "The washbasin depth you have chosen is not sufficient. Would you like to set the required depth of {requiredDepth} mm for this disposal?",
  },
  cornerDesignLabelWithout: {
    id: "CornerDesignLabelWithout.without",
    defaultMessage: "Without corner design",
  }, 
  cornerDesignLabelRadius: {
    id: "CornerDesignLabelRadius.radius",
    defaultMessage: "Radius (100 mm)",
  },
  cornerDesignLabelBevel: {
    id: "CornerDesignLabelBevel.bevel",
    defaultMessage: "Bevel (side length 100 mm)",
  },
  distancesPositionSymmetrically: {
    id: "DistancesPosition.symmetrically",
    defaultMessage: "Position Symmetrically",
  },
  distancesPositionEvenly: {
    id: "DistancesPosition.evenly",
    defaultMessage: "Position Evenly",
  },
  distancesPositionOfTroughs: {
    id: "DistancesPositionOfTroughs.distances",
    defaultMessage: "Input of the trough center distance",
  },
  distancesPositionOfTroughsHint: {
    id: "DistancesPositionOfTroughsHint.hint",
    defaultMessage: "Note:",
  },
  distancesPositionOfTroughsMessage: {
    id: "DistancesPositionOfTroughsMessage.message",
    defaultMessage: "Advantages and recommendations for use",
  },
  distancesPositionOfTroughsFromPlate: {
    id: "DistancesPositionOfTroughsFromPlate.plate",
    defaultMessage: "From plate to rear edge of trough",
  },
  plateDimensionsWidth: {
    id: "PlateDimensionsWidth.width",
    defaultMessage: "Plate width",
  },
  plateDimensionsDepth: {
    id: "PlateDimensionsDepth.depth",
    defaultMessage: "Plate depth",
  },
  plateDimensionsDepth470: {
    id: "PlateDimensionsDepth.470",
    defaultMessage: "Recommendation for wall fittings",
  },
  plateDimensionsDepth550: {
    id: "PlateDimensionsDepth.550",
    defaultMessage: "Recommendation for stand fittings",
  },
  plateDimensionsDepthIndividual: {
    id: "PlateDimensionsDepth.depthIndividual",
    defaultMessage: "Individual",
  },
  plateDimensionsError: {
    id: "Configuration.Inputs.BasinDimenisons.PlateDimensions",
    defaultMessage: "Your value is out of range",
  },
  angleOfNicheLabelLeft: {
    id: "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left",
    defaultMessage: "Left side",
  },
  angleOfNicheLabelRight: {
    id: "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right",
    defaultMessage: "Right side",
  },
  angleOfNicheNotSelectAble: {
    id: "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble",
    defaultMessage: "Only possible in combination with type of installation \"with, left or right\".",
  },
  cornerDesignNotSelectAble: {
    id: "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble",
    defaultMessage: "Only possible in combination with type of installation \"without, left or right\".",
  },
  inputOutOfRangeError: {
    id: "Configuration.Inputs.message",
    defaultMessage: "Your value is out of range",
  },
  distancesInmm: {
    id: "Configuration.Inputs.distancesInmm",
    defaultMessage: "(distances in mm)",
  },
  dimensionsRequiredHint: {
    id: "PlateDimensionsRequired.hint",
    defaultMessage: "Note:",
  },
  dimensionsRequiredMessage: {
    id: "PlateDimensionsRequired.message",
    defaultMessage: "The width of your washbasin is not sufficient. To place an apron, the plate must be enlarged. Would you like to continue?",
  },
  dimensionsRequiredLimitMessage: {
    id: "PlateDimensionsRequiredLimit.message",
    defaultMessage: "Maximum washbasin width reached. No apron selection possible.",
  },
  dimensionsChoiceMessage: {
    id: "PlateDimensionsChoice.message",
    defaultMessage: "There is not enough space for an apron on your washbasin. You have the following options to proceed:",
  },
  dimensionsChoiceLimitMessage: {
    id: "PlateDimensionsChoiceLimit.message",
    defaultMessage: "There is not enough space for an apron on your washbasin. Maximum washbasin width reached. You have the following options to proceed:",
  },
  dimensionsChoiceIncrease: {
    id: "PlateDimensionsChoice.increase",
    defaultMessage: "Change the width of the washbasin",
  },
  dimensionsChoiceMove: {
    id: "PlateDimensionsChoice.move",
    defaultMessage: "Move the trough(s) and keep the width of the washbasin",
  },
  dimensionsChoiceCancel: {
    id: "PlateDimensionsChoice.cancel",
    defaultMessage: "Cancel (keep the dimensions without an apron)",
  }
});

export default MESSAGES;